import logo from './logo.svg';
import React from 'react';

import './App.css';
import { Row, Col, Button, Card, Tag, Typography, Layout, Menu, Anchor, ConfigProvider } from 'antd';
import { useEffect, useRef, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { QueryClient, QueryClientProvider } from 'react-query';

import axios from 'axios';
import remarkGfm from 'remark-gfm';
import { createBrowserRouter, Navigate, RouterProvider, useLocation, useNavigate } from 'react-router-dom';

import LoginSignupPage from './pages/signInUp';
import LabelHome from './pages/label';
import LabelTaskPage from './pages/labelTask';
import { ProviderAuth, useAuth } from './authContext';
import LLMExperiments from './predictions';
import BookmarkPage from './pages/bookmarks';
import PubmedDataHomeV2 from './pages/pubmedDataV2';
import ValidationView from './pages/validation';
import ValidationSets from './pages/validationSets';
import PubmedDataDetail from './pages/pubmedDataDetail';
import PubmedSearch from './pages/pubmedSearch';
import AllSummary from './pages/gptSummary/allSummary';
import Scoring from './pages/scoring';
import v2Router from './v2/app';
import { FiltersProvider } from './hooks/filters';
import ReferenceCheck from './v2/pages/referenceCheck';

const protectedRouter = createBrowserRouter([
  {
    path: '/llm',
    element: (
      <div>
        <LLMExperiments />
      </div>
    ),
  },
  {
    path: '/label/:id',
    element: <LabelHome />,
  },
  {
    path: '/label',
    element: <LabelTaskPage />,
  },
  {
    path: '/pubmed-search',
    element: <PubmedSearch />,
  },

  {
    path: '/validation',
    element: <ValidationSets />,
  },
  {
    path: '/validation/:id',
    element: <ValidationView />,
  },

  // Legacy routes - moved to /legacy prefix
  {
    path: '/legacy/dataset',
    element: <PubmedDataHomeV2 />,
  },
  {
    path: '/legacy/dataset/:id',
    element: <PubmedDataDetail />,
  },
  {
    path: '/legacy/scoring',
    element: <Scoring />,
  },
  {
    path: '/legacy/bookmarks',
    element: <BookmarkPage />,
  },
  {
    path: '/legacy/gpt-summary',
    element: <AllSummary />,
  },
  {
    path: '/legacy/fact-check',
    element: <ReferenceCheck header={true} />,
  },

  // Main v2 routes (now at root level)
  v2Router,

  {
    path: '/*',
    element: <Navigate to="/dashboard" />,
  },
]);

const baseRouter = createBrowserRouter([
  {
    path: '/login',
    element: (
      <div>
        <LoginSignupPage />
      </div>
    ),
  },
  {
    path: '/*',
    element: (
      <div>
        <Navigate to="/login" />
      </div>
    ),
  },
]);

const queryClient = new QueryClient();

const App = () => {
  const auth = useAuth();

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider
          theme={{
            token: {
              // fontFamily: "Nunito Sans",
              fontFamily: 'IBM Plex Sans',
              borderRadius: '8px',
            },
          }}
        >
          {auth.loading && 'Loading...'}
          {!auth.loading ? (
            auth.isAuthenticated ? (
              <>
                <FiltersProvider>
                  <RouterProvider router={protectedRouter} />
                </FiltersProvider>
              </>
            ) : (
              <RouterProvider router={baseRouter} />
            )
          ) : null}
        </ConfigProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
};

const FinalApp = () => {
  return (
    <React.StrictMode>
      <ProviderAuth>
        <App />
      </ProviderAuth>
    </React.StrictMode>
  );
};
export default FinalApp;
